import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { ShopCartItem } from '@/types/shop';

export const SHOP_CART_STORAGE_KEY = 'aa-shop-cart';

interface ShopCartState {
  userId: number | null;
  items: ShopCartItem[];
  bindUser: (userId: number) => void;
  add: (item: ShopCartItem) => void;
  remove: (optionId: number) => void;
  setQuantity: (optionId: number, quantity: number) => void;
  clear: () => void;
  resetForLogout: () => void;
}

export const useShopCartStore = create<ShopCartState>()(
  persist(
    (set, get) => ({
      userId: null,
      items: [],
      bindUser: (userId) => {
        if (get().userId !== userId) set({ userId, items: [] });
      },
      add: (item) => set((state) => {
        const withoutOtherPlan = item.kind === 'plan' ? state.items.filter((existing) => existing.kind !== 'plan') : state.items;
        const existing = withoutOtherPlan.find((entry) => entry.optionId === item.optionId);
        if (existing) return {
          items: withoutOtherPlan.map((entry) => entry.optionId === item.optionId
            ? { ...entry, quantity: item.kind === 'plan' ? 1 : Math.min(entry.quantity + item.quantity, 99) }
            : entry),
        };
        return { items: [...withoutOtherPlan, { ...item, quantity: item.kind === 'plan' ? 1 : Math.max(1, item.quantity) }] };
      }),
      remove: (optionId) => set((state) => ({ items: state.items.filter((entry) => entry.optionId !== optionId) })),
      setQuantity: (optionId, quantity) => set((state) => ({
        items: state.items.map((entry) => entry.optionId === optionId
          ? { ...entry, quantity: entry.kind === 'plan' ? 1 : Math.min(99, Math.max(1, quantity)) }
          : entry),
      })),
      clear: () => set({ items: [] }),
      resetForLogout: () => set({ userId: null, items: [] }),
    }),
    {
      name: SHOP_CART_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ userId: state.userId, items: state.items }),
    },
  ),
);
